import React, { useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { useSessionContext } from 'components/Session';
import { userAuthSetup } from 'api';
import { AiOutlineMail } from 'react-icons/ai';
import log from 'loglevel';
import 'sass/login.scss';
import AwaitingConfirmation from './AwaitingConfirmation';
import ReceivedConfirmationCode from './ReceivedConfirmationCode';
import { SwitchTransition } from 'react-transition-group';
import { CSSTransition } from 'react-transition-group';


const EMAIL_ADDRESS_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


const EnterEmailForm = ({
    email,
    setEmail,
    setConfirmationId,
    setLoginState,
    companyName,
    event: { quarter }
  }) => {

  const { sessionContext } = useSessionContext();
  const [ signUpLoading, setSignUpLoading ] = useState(false);
  const [ isEmailValid, setIsEmailValid ] = useState(false);
  const [ validated, setValidated ] = useState(false);

  const emailChangedHandler = ({ target: { value: newEmailAddress } }) => {
    setEmail(newEmailAddress);
    setIsEmailValid(EMAIL_ADDRESS_REGEX.test(newEmailAddress));
  };

  const submitLoginFormHandler = (event) => {
    log.debug(`signUpHandler:`, event);
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);
    log.debug("window.location", window.location);
    const { location: { origin } } = window;
     const form = event.currentTarget;
    if (form.checkValidity()) {
      setSignUpLoading(true);
      const data = {
        type: "send-confirmation-email",
        origin,
        email,
      };
      if (isEmailValid) {
        userAuthSetup({ data, context: { sessionContext } })
          .then((result) => {
            log.debug("LoginWithEmailForm result", result);
            setSignUpLoading(false);
            setLoginState("awaiting-confirmation");
            setConfirmationId(result.confirmation_id);
          });
      } else {

      }
    }
  };

  return (
    <>
      <Form noValidate validated={validated} onSubmit={submitLoginFormHandler}>
        <div className="form-group">
          <label htmlFor="emailAddressField">
            We'll send you an email alert when the {quarter.toUpperCase()} {companyName} is available.
          </label>
          <input
            type="email"
            className="form-control"
            id="emailAddressField"
            aria-describedby="emailHelp"
            placeholder="Enter email"
            value={email}
            onChange={emailChangedHandler}
            required
          />
          <div className="invalid-feedback">
            Please provide a valid email address.
          </div>
        </div>
        <button
          disabled={!!signUpLoading}
          type="submit"
          className="btn btn-primary"
        >
          { signUpLoading ?
            <>
              <Spinner
                as="span"
                animation="grow"
                role="status"
                aria-hidden="true"
                size="sm"
              />
              Loading...
            </>
            :
            <>
              Sign-Up for Email Alerts
            </>
          }
        </button>
      </Form>
    </>
  )
};

const LoginWithEmailModal = (props) => {
  const [ email, setEmail ] = useState("");
  const [ confirmationId, setConfirmationId ] = useState();
  const [ confirmationCode, setConfirmationCode ] = useState();
  const [ showModal, setShowModal ] = useState(false);
  const [ loginState, setLoginState ] = useState("initial");

  const handleClose = () => {
    setShowModal(false);
  };

  const subProps = {
    ...props,
    email,
    setEmail,
    confirmationId,
    setConfirmationId,
    confirmationCode,
    setConfirmationCode,
    setLoginState,
  };

  const getModalBodySubComponent = () => {
    switch (loginState) {
      case "initial":
        return <EnterEmailForm {...subProps} />;
      case "awaiting-confirmation":
        return <AwaitingConfirmation {...subProps} />;
      case "received-confirmation-code":
        return <ReceivedConfirmationCode {...subProps} />;
      default:
        return <></>
    }
  };

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleClose}
        dialogClassName=""
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Enter your email
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SwitchTransition>
            <CSSTransition
              key={loginState}
              addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
              classNames="fade"
            >
              { getModalBodySubComponent() }
            </CSSTransition>
          </SwitchTransition>
        </Modal.Body>
      </Modal>
      <button type="button" onClick={() => setShowModal(true)} className="btn btn-primary" data-toggle="modal">
        <AiOutlineMail />
        <span className="text">SignUp for Alerts</span>
      </button>
    </>
  );
};


export default (props) => {

  return (
    <>
      <li className="list">
        <LoginWithEmailModal {...props} />
      </li>
    </>
  );

};
